export default [
  {
    path: 'home',
    name: 'home',
    component: resolve => require(['@/views/home'], resolve),
  },
  {
    path: 'workflow',
    name: 'workflow',
    component: resolve => require(['@/views/workflow'], resolve),
  },
  {
    path: 'quickNav',
    name: 'quickNav',
    component: resolve => require(['@/views/quickNav/index.vue'], resolve),
  },
  {
    path: 'electronicInvoice', // 全电开票
    name: 'electronicInvoice',
    component: resolve => require(['@/views/electronicInvoice'], resolve),
  },
  {
    path: 'reimbursementList',
    name: 'reimbursementList',
    component: resolve => require(['@/views/reimbursement'], resolve),
  },
  {
    path: 'invoice', // 开票
    name: 'invoice',
    component: resolve => require(['@/views/invoice'], resolve)
  },
  {
    path: 'nonoInvoice', // 汇丰，中智信开票
    name: 'nonoInvoice',
    component: resolve => require(['@/views/nonoInvoice'], resolve)
  },
  {
    path: 'technicalManagement',
    name: 'technicalManagement',
    redirect: '/base/BaseSysNav'
  },
  {
    path: 'hainanElectronicGuarantee',
    name: 'hainanElectronicGuarantee',
    redirect: '/heg/ElectronSysNav'
  },
  {
    path: 'biaoXinTong',
    name: 'biaoXinTong',
    redirect: '/bxt/BxtSysNav'
  },
  {
    path: 'huiZhou',
    name: 'huiZhou',
    redirect: '/hz/HzSysNav'
  },
  {
    path: 'huaQiaoChen',
    name: 'huaQiaoChen',
    redirect: '/hqc/HqcSysNav'
  },
  {
    path: 'xinHaiNan', //新点 - 海南
    name: 'xinHaiNan',
    redirect: '/newHeg/newHegSysNav'
  },
  {
    path: 'xdzz', //新点 - 漳州
    name: 'xdzz',
    redirect: '/xdZhZh/xdZZSysNav'
  },
  {
    path: 'socialSecurity', //社保农民工工资保函
    name: 'socialSecurity',
    redirect: '/social/SocialSysNav'
  },
  {
    path: 'ystSystem', //粤商通
    name: 'ystSystem',
    redirect: '/yst/ystSysNav'
  },
  // {
  //   path: 'hnSystem', //湖南
  //   name: 'hnSystem',
  //   redirect: '/hn/hnSysNav'
  // },
  {
    path: 'xwSystem', // 新网
    name: 'xwSystem',
    redirect: '/newNet/newNetSysNav'
  },
  {
    path: 'hnSystem', //湖南交易中心
    name: 'hnSystem',
    redirect: '/hn/HNSysNav'
  },
  {
    path: 'hndbSystem', //湖南交易中心(河北亿恒、中康惠众)
    name: 'hndbSystem',
    redirect: '/hndb/HNDBSysNav'
  },
  {
    path: 'channelManage',  //渠道系统
    name: 'channelManage',
    redirect: '/channel/channelList' //渠道列表
  },
  {
    path: 'departemnt',  //部门管理
    name: 'departemnt',
    redirect: '/ehr/DepartemntManage' //部门管理
  },
]